import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import './index.scss';
import { hotjar } from 'react-hotjar';
import TagManager from 'react-gtm-module';
import * as amplitude from '@amplitude/analytics-browser';
import { AMPLITUDE_API_KEY } from './utils/keys';

const tagManagerArgs = {
  gtmId: 'GTM-MQQ6MJ9',
};

ReactDOM.render(<App />, document.getElementById('root'));

hotjar.initialize(1926311, 6);
TagManager.initialize(tagManagerArgs);

amplitude.init(AMPLITUDE_API_KEY, {
  autocapture: false,
  defaultTracking: {
    sessions: true,
  },
});
